module.exports = __webpack_public_path__ + "static/media/wK.27fd3307.svg";